<script>
    import elementResizeDetectorMaker from 'element-resize-detector'

    const erd = elementResizeDetectorMaker({
        strategy: 'scroll'
    })

    export default {
        props: {
            once: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                width: null,
                height: null
            }
        },
        mounted () {
            erd.listenTo(this.$el, (el) => {
                this.width = el.offsetWidth
                this.height = el.offsetHeight

                if (this.once) this.$nextTick(() => erd.uninstall(this.$el))
            })
        },
        beforeDestroy () {
            erd.removeAllListeners(this.$el)
        },
        render () {
            return this.$scopedSlots.default({
                width: this.width,
                height: this.height
            })
        }
    }
</script>
